<div class="row">
  <div class="col">
    <div class="page-nav-header no-pills">
      <div class="back-container">
        <button type="button" class="btn btn-transparent p-0" (click)="helperService.goBack()" aria-label="back">
          <fa-icon icon="arrow-left" class="circle-icon-btn" aria-hidden="true"></fa-icon>
          <span class="sr-only">back</span>
        </button>
        <fui-heading [text]="ticket ? ticket.subject : ('general.loading_dots' | translate)" [level]="2" fontSize="f9"></fui-heading>
      </div>
      <div class="buttons">
        <span class="fui-action-btn" (click)="addComment()">
          <fa-icon icon="plus-square"></fa-icon>
          &nbsp;{{ "support.add_comment" | translate }}
        </span>
        @if (ticket && ticket.can_be_solved_by_me) {
          <span class="btn btn-primary" (click)="markAsSolved()">
            <fa-icon icon="check-square"></fa-icon>
            &nbsp;{{ "support.mark_as_solved" | translate }}
          </span>
        }
      </div>
    </div>
  </div>
</div>

<myp-inline-loader [loading]="loading" height="200px" spinnerName="ticketDetailLoader"></myp-inline-loader>

@if (!loading) {
  @for (comment of details; track comment) {
    <div class="comment row" [class.me]="!comment.agent">
      @if (comment.agent) {
        <div class="d-none d-sm-block col-sm-2 col-lg-1">
          @if (comment.author_photo) {
            <img [src]="comment.author_photo" class="author-photo" />
          }
        </div>
      }
      <div class="col-sm-10 col-md-8" [class.offset-md-2]="!comment.agent" [class.offset-lg-3]="!comment.agent">
        <div class="comment-body" [class.me]="!comment.agent">
          <span [innerHTML]="comment.html_body"></span>
          @if (comment.attachments && comment.attachments.length) {
            <span class="b m-y-10 t-12">{{ "Attachments" | uppercase }}</span>
            @for (att of comment.attachments; track att) {
              <div>
                @if (att.thumbnails && att.thumbnails.length) {
                  <img (click)="showImage(att.content_url)" [src]="att.content_url" />
                }
                @if (!att.thumbnails || !att.thumbnails.length) {
                  <a [href]="att.content_url" target="_blank">{{ att.file_name }}</a>
                }
              </div>
            }
          }
        </div>
      </div>
      @if (!comment.agent) {
        <div class="d-none d-sm-block col-sm-2 col-lg-1">
          @if (comment.author_photo) {
            <img [src]="comment.author_photo" class="author-photo" />
          }
        </div>
      }
      <div class="col-sm-10 col-md-8 offset-2 author-details" [class.offset-lg-1]="comment.agent" [class.offset-lg-3]="!comment.agent" [class.text-left]="!comment.agent">
        {{ comment.author_name + " - " + comment.created_at_pretty }}
      </div>
    </div>
  }
}
